import { Box, Chip, CircularProgress } from '@mui/material';
import {
  DataGridPro as DataGrid,
  GridActionsCellItem,
} from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import * as service from '../../services/jobs-service';

export function Jobs() {
  const [jobs, setJobs] = useState();
  const [jobLoading, setJobLoading] = useState();

  useEffect(() => {
    service.getAllJobs().then(setJobs);
  }, []);

  return (
    <Box
      sx={{
        p: 2,
        height: '100%',
      }}
    >
      <DataGrid
        loading={!jobs}
        columns={buildColumns()}
        rows={jobs || []}
        hideFooter={false}
        initialState={{
          filter: {
            filterModel: {
              items: [
                { field: 'status', operator: 'equals', value: 'delayed' },
              ],
            },
          },
        }}
      />
    </Box>
  );

  async function handleRunNowClick(row) {
    setJobLoading(row.id);
    await service.runJob(row.queueName);
    setJobLoading(null);
    service.getAllJobs().then(setJobs);
  }

  function RunJobButton({ row }) {
    const loading = row.id === jobLoading;
    return (
      <Box sx={{ m: 1, position: 'relative' }}>
        {row.id === jobLoading && (
          <CircularProgress
            size={24}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
        <Chip
          label="Run Now"
          color={loading ? 'default' : 'primary'}
          sx={{ display: 'flex' }}
        />
      </Box>
    );
  }

  function buildRowActions(row) {
    return row.status === 'delayed'
      ? [
          <GridActionsCellItem
            label="Run Now"
            title="Run Now"
            icon={<RunJobButton row={row} />}
            data-testid={`run-now-${row.id}`}
            onClick={() => handleRunNowClick(row)}
            disableRipple={true}
            disabled={row.id === jobLoading}
            sx={{ background: 'transparent !important' }}
          />,
        ]
      : [];
  }

  function buildColumns() {
    return [
      {
        field: 'queueName',
        headerName: 'Queue',
        flex: 1,
      },
      {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        valueGetter: ({ row }) =>
          [
            row.status?.toUpperCase(),
            row.failedReason && `(${row.failedReason})`,
          ]
            .filter(Boolean)
            .join(' '),
      },
      {
        field: 'delay',
        headerName: 'When',
        flex: 1,
        valueGetter: ({ row }) =>
          row.delay
            ? new Date(row.timestamp + row.delay).toLocaleString()
            : new Date(row.timestamp).toLocaleString(),
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: '',
        flex: 1,
        getActions: ({ row }) => buildRowActions(row),
      },
    ];
  }
}
